import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "GBC's tungsten carbide dies have significantly improved our aerospace component production efficiency. Their quality, durability, and precision are unmatched in the industry.",
      name: "Nikunj Bansal",
      position: "Production Manager",
      company: "Aerospace Dynamics Ltd."
    },
    {
      id: 2,
      text: "We've been using GBC's electroplated diamond tools for our electronics manufacturing for over a decade. Their consistency, performance, and technical support have been exceptional throughout our partnership.",
      name: "Rahul Srivastav",
      position: "Operations Director",
      company: "Precision Electronics Inc."
    },
    {
      id: 3,
      text: "The custom abrasives GBC developed for our automotive parts manufacturing exceeded our expectations. They truly understand our industry needs and deliver solutions that enhance precision while extending tool life.",
      name: "Aakash Agarwal",
      position: "Chief Engineer",
      company: "Advanced Automotive Tech"
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonials-section home-section">
      <div className="section-header">
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="section-subtitle">
          Trusted by leading companies in aerospace, automotive, electronics, and precision manufacturing industries
        </p>
      </div>

      <div className="testimonials-container">
        <div className="testimonials-carousel">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className={`testimonial-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <div className="quote-icon">❝</div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-position">{testimonial.position}, {testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="carousel-controls">
          <button className="carousel-control prev" onClick={prevSlide}>
            &#10094;
          </button>
          <div className="carousel-indicators">
            {testimonials.map((_, index) => (
              <button 
                key={index} 
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
          <button className="carousel-control next" onClick={nextSlide}>
            &#10095;
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
